<script>
    export let terminy = [{}];

    function removeTermin(index) {
        if (index >= 0 && index < terminy.length) {
            terminy.splice(index, 1);
        }

        terminy = terminy;
    }
</script>

{#if terminy.length > 0}
<div id="shrnuti_terminu" class="shrnutiTerminu">
    <p><strong>Vybrané termíny</strong></p>
    {#each terminy as termin, i}
        <div id="termin-section-{termin["start_time"]}" class="termin-section">
            <label for="zrusit-{i}" class="termin">{new Date(termin["start_time"]).toLocaleString("cs-CZ", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            })}</label>
            <button id="zrusit-{i}" on:click|preventDefault={() => removeTermin(i)}>Zrušit</button> 
        </div>
    {/each}
</div>
{/if}

<style>
    .termin-section {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 30%;
        align-items: center;
    }

    label.termin {
        padding: 0;
        margin: 0;
    }

    button {
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        list-style-type: none!important;
        box-sizing: border-box;
        text-transform: uppercase;
        font-size: 12px;
        cursor: pointer;
        position: relative;
        line-height: 1 !important;
        font-style: normal !important;
        vertical-align: middle;
        transition: .3s;
        text-shadow: none!important;
        font-family: Lato,Helvetica,Arial,sans-serif;
        text-align: center;
        font-weight: 700;
        text-decoration: none!important;
        display: block;
        letter-spacing: 0;
        color: #fff !important;
        border: 1px solid #bc9321;
        outline: 0;
        padding: 0.5em 1em;
        box-shadow: none !important;
        border-color: #df6b6b !important;
        background: #df6b6b !important;
        border-radius: 99em;
    }

    button:hover {
        border-color: #994c4c !important;
        background: #994c4c !important;
    }
</style>
